// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";
import "firebase/analytics";
import "firebase/firestore";
import "firebase/database";
import "firebase/storage";
import "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCsCBZduxxkhPdTXMBKjXq_YH0pCH-o0Pg",
    authDomain: "the5th-49533.firebaseapp.com",
    projectId: "the5th-49533",
    storageBucket: "the5th-49533.appspot.com",
    messagingSenderId: "441317597404",
    appId: "1:441317597404:web:28f7efbbd7a0bb58425419",
    measurementId: "G-D1QR4YEPF2"
};

//the old 5th config
// const firebaseConfig = {
//     apiKey: "AIzaSyCBMfBE7Z4gx1ZNHxKmgYb_-kaMpmvvcwI",
//     authDomain: "fifth-platform.firebaseapp.com",
//     databaseURL: "https://fifth-platform.firebaseio.com",
//     projectId: "fifth-platform",
//     storageBucket: "fifth-platform.appspot.com",
//     messagingSenderId: "1006032807167",
//     appId: "1:1006032807167:web:a54575736bbc7c385258ca"
// };

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

const database = firebase.firestore();
const storage = firebase.storage();

export { firebase, database, storage }